import React from 'react';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { startOfWeek, undoDateFormat, textfieldDateFormat, dateFormat, adjustDateByStockItem } from "../../../utils/dateFunctions";
import ControlledTextField from "../../../components/ControlledTextField";
import Div from "@jumbo/shared/Div";
import IconButton from '@mui/material/IconButton';
import { useJumboTheme } from "@jumbo/hooks";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import DatePicker from "../../../shared/DatePicker";
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { getOysterGrades, buildSpeciesList } from '../../../definitions/oysters';
import AddIcon from '@mui/icons-material/Add';
import FormModal from '../../../components/FormModal';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import SubmitButtonDisplayer from "../../../components/SubmitButtonDisplayer";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { ACCESS, ACCESS_SECTIONS } from '../../../utils/constants/access';
import StaffMember from "../../../components/StaffMember";
import SelectWarehouse from "../../../components/SelectWarehouse";
import { checkAccess } from '../../../utils/roleFunctions';
import { getAPIDataParamsReturn, postApi, getAPIData, getAPIDataParams } from "../../../utils/apiFunction";
import { userInfo } from '../../../../adalConfig';
import { Table, TableBody, TableCell, TableHead, TableRow, ToggleButtonGroup, ToggleButton, Typography } from "@mui/material"
import { SelectTextFieldNew as SelectTextField } from "../../../components/SelectTextField";
import JumboSearch from '../../../../@jumbo/components/JumboSearch';
import DownloadIcon from '@mui/icons-material/Download';
import { v4 as uuidv4 } from 'uuid';
import { convertToCSV, DownloadButton } from 'app/utils/downloadUtils';
import { Info, Warehouse } from '@mui/icons-material';
import InventoryHistory from '../Tables/InventoryHistory';

const PriceForm = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const [completed, setCompleted] = React.useState(props.completed);
    const [staffMember, setStaffMember] = React.useState(null);
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [invHistOpen, setInvHistOpen] = React.useState(false);
    const [invHistSI, setInvHistSI] = React.useState(null);
    const [invHistLSN, setInvHistLSN] = React.useState(null);
    const [currStockItems, setcurrStockItems] = React.useState([]);
    const [date, setDate] = React.useState(props.date ? props.date : new Date());
    const [comments, setComments] = React.useState(null);
    const [currentStock, setCurrentStock] = React.useState(null);
    const [oysters, setOysters] = React.useState([]);
    const [returnData, setReturnData] = React.useState(null);
    const [stockItems, setStockItems] = React.useState([]);
    const [warehouse, setWarehouse] = React.useState(null);
    const [currentEntries, setCurrentEntries] = React.useState(null);
    const [outputsPassedGroup, setOutputsPassedGroup] = React.useState([]);
    const [reload, setReload] = React.useState(false);
    const [grades, setGrades] = React.useState([]);
    const [speciesList, setSpeciesList] = React.useState([]);
    const [fullList, setFullList] = React.useState([]);
    const [newLines, setNewLines] = React.useState(false);
    const [lineLoading, setLineLoading] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [inventory, setInventory] = React.useState(null);
    const [createLoading, setCreateLoading] = React.useState(false);
    const [currentStocktake, setCurrentStocktake] = React.useState(null);
    const [editST, setEditST] = React.useState(false);
    const [newList, setNewList] = React.useState([]);
    const [sortKey, setSortKey] = React.useState({ main: 'expiryDate', second: null });
    const [filterChoice, setFilterChoise] = React.useState(('null-null'));
    const id = props.data ? props.data.id : '';
    const [user, setUser] = React.useState(userInfo());
    const frozenStocktake = false;
    const Swal = useSwalWrapper();
    const requiredEditAccess = { key: ACCESS_SECTIONS.PROCESSING, value: ACCESS.EDIT };
    const requiredApprovalAccess = { key: ACCESS_SECTIONS.PROCESSING, value: ACCESS.ADMIN };
    const [stocktakeTests, setStockTakeTests] = React.useState(null);
    const [currentStocktakeId, setCurrentStocktakeId] = React.useState(props.selStocktakeId ? props.selStocktakeId : props.currentStocktakeId);
    const isComplete = currentStocktake ? currentStocktake.isComplete : false;
    const isApproved = currentStocktake ? (((currentStocktake.syncedToMYOB) || (currentStocktake.approvedBy !== null)) ? true : false) : false;
    const dummyFunction = async () => { return [] };
    const getInvData = React.useCallback(async () => {
        // Ask API to combine mixed groups when possible
        return await getAPIDataParamsReturn('/Inventory/Get', { WarehouseId: props.warehouseId, ExcludeTransfers: true, GroupByMixedGroupId: true }).then((raw) => {
            // Client-side safety: combine any mixed items by mixedGroupId if backend didn't
            const combineMixed = (list) => {
                const byGroup = new Map();
                const singles = [];
                (list || []).forEach(item => {
                    const mgid = item?.mixedGroupId || item?.MixedGroupId;
                    if (mgid) {
                        if (!byGroup.has(mgid)) byGroup.set(mgid, []);
                        byGroup.get(mgid).push(item);
                    } else {
                        singles.push(item);
                    }
                });
                const combined = Array.from(byGroup.entries()).map(([mgid, items]) => {
                    const base = items[0];
                    const total = items.reduce((p, x) => p + Number(x?.portalQuantity ?? 0), 0);
                    // Build percentage breakdown for description
                    const parts = items.map(it => {
                        const qty = Number(it?.portalQuantity ?? 0);
                        const pct = total > 0 ? Math.round((qty / total) * 100) : 0;
                        const name = it?.stockItem?.description || it?.stockItemName || `Item ${it?.stockItemId ?? ''}`;
                        return `${name} ${pct}%`;
                    });
                    const desc = parts.join(' / ');
                    const groupItems = items.map(it => ({
                        stockItemId: it?.stockItemId || it?.stockItem?.id,
                        stockItem: it?.stockItem,
                        portalQuantity: Number(it?.portalQuantity ?? 0),
                    }));
                    return {
                        ...base,
                        portalQuantity: total,
                        mixedGroupId: mgid,
                        stockItemId: null,
                        stockItem: { description: desc },
                        groupItems,
                    };
                });
                return [...singles, ...combined];
            };
            const data = combineMixed(raw).filter((d) => {
                if (frozenStocktake) {
                    return d.stockItem?.isFrozen;
                } else {
                    return !d.stockItem?.isFrozen;
                }
            });
            return data;
        });
    }, [props.warehouseId]);
    React.useEffect(() => {
        getOysterGrades().then((data) => {
            setGrades(data);
            var specs = buildSpeciesList(data);
            setSpeciesList(specs);
        });
    }, []);
    React.useEffect(() => {
        if (!currentStocktakeId) {
            getAPIDataParams('/Inventory/StockTakeReady', setStockTakeTests, { WarehouseId: props.warehouseId })
        }
    }, []);
    React.useEffect(() => {
        setLoading(true);
        setInventory(null);

        if (currentStocktakeId) {
            getAPIDataParamsReturn('/Inventory/GetStocktake', { StocktakeId: currentStocktakeId }).then((cs) => {
                const localIsApproved = ((cs.syncedToMYOB) || (cs.approvedBy !== null)) ? true : false;
                const localIsComplete = ((cs.isComplete)) ? true : false;

                // Combine stocktake lines by MixedGroupId (if present), Lot and Expiry BEFORE matching to inventory
                const combineStocktakeLines = (lines) => {
                    const map = new Map();
                    const keyFor = (l) => {
                        const mgid = l?.mixedGroupId || l?.MixedGroupId || null;
                        const lot = l?.lotSerialNbr || '';
                        const exp = l?.expiryDate || '';
                        if (mgid) return `g:${mgid}|${lot}|${exp}`; // group by mixed group
                        const si = l?.stockItemId || '';
                        return `i:${si}|${lot}|${exp}`; // otherwise by stock item
                    };
                    (lines || []).forEach((l) => {
                        const k = keyFor(l);
                        if (!map.has(k)) {
                            map.set(k, {
                                // representative fields
                                id: l.id,
                                allIds: [l.id],
                                mixedGroupId: l?.mixedGroupId || l?.MixedGroupId || null,
                                stockItemId: l?.stockItemId || null,
                                lotSerialNbr: l?.lotSerialNbr,
                                expiryDate: l?.expiryDate,
                                newQuantity: Number(l?.newQuantity ?? 0),
                                oldQuantity: Number(l?.oldQuantity ?? 0),
                                // approvals aggregate: only true if all true
                                isApproved: l?.isApproved === true,
                                binned: l?.binned === true,
                                description: l?.description || '',
                            });
                        } else {
                            const agg = map.get(k);
                            agg.allIds.push(l.id);
                            agg.newQuantity += Number(l?.newQuantity ?? 0);
                            agg.oldQuantity += Number(l?.oldQuantity ?? 0);
                            agg.isApproved = agg.isApproved && (l?.isApproved === true);
                            agg.binned = agg.binned || (l?.binned === true);
                            agg.description = agg.description || l?.description || '';
                        }
                    });
                    return Array.from(map.values());
                };
                const combinedStocktakeLines = combineStocktakeLines(cs.stocktakeLines);
                const stocktakeLineById = new Map((cs.stocktakeLines || []).map(l => [l.id, l]));

                (localIsApproved ? dummyFunction() : getInvData()).then((data) => {
                    setCreateLoading(false);
                    setLoading(false);
                    var nFL = [];
                    var nInv = [];
                    var nonNewEntries = [];
                    for (var i = 0; i < data.length; i++) {
                        // Match against COMBINED stocktake lines (grouped by mixedGroupId/lot/expiry)
                        var ExistCS = combinedStocktakeLines.find((c) => {
                            const mgidInv = data[i]?.mixedGroupId || data[i]?.MixedGroupId;
                            const matchByGroup = mgidInv && (c?.mixedGroupId === mgidInv);
                            const matchByItem = (!mgidInv) && (!c?.mixedGroupId) && (c?.stockItemId === data[i].stockItemId);
                            return (matchByGroup || matchByItem) && (c.expiryDate === data[i].expiryDate) && (c.lotSerialNbr === data[i].lotSerialNbr);
                        });
                        if (ExistCS) {
                            // Mark all underlying raw lines as used to avoid duplicates later
                            if (Array.isArray(ExistCS.allIds)) {
                                ExistCS.allIds.forEach((lid) => {
                                    const raw = stocktakeLineById.get(lid);
                                    if (raw) nonNewEntries.push(raw);
                                });
                            } else if (ExistCS.id) {
                                const raw = stocktakeLineById.get(ExistCS.id) || ExistCS;
                                nonNewEntries.push(raw);
                            }
                        }
                        var Approved = false;
                        if (ExistCS?.isApproved === null || ExistCS?.isApproved === undefined) {
                            // Approved = (ExistCS?.newQuantity === data[i].portalQuantity);
                        } else {
                            Approved = ExistCS?.isApproved;
                        }
                        // Always include mixedGroupId from inventory for fullList
                        const mixedGroupId = data[i]?.mixedGroupId || data[i]?.MixedGroupId || null;
                        const allIds = ExistCS?.allIds || null;
                        if (!(localIsComplete && !ExistCS)) {
                            nFL.push({ stocktakeLineId: ExistCS?.id, isApproved: ExistCS?.isApproved, id: i, quantity: ExistCS ? ExistCS.newQuantity : null, Approved: Approved, mixedGroupId, allIds, binned: ExistCS?.binned === true, description: ExistCS?.description || '' });
                            nInv.push({ stocktakeLineId: ExistCS?.id, ...data[i], id: i, touched: ExistCS ? true : false, stocktakeQuantity: ExistCS ? ExistCS.newQuantity : null, Approved: Approved, stocktakeOldQuantity: ExistCS ? ExistCS.oldQuantity : null, mixedGroupId, allIds, binned: ExistCS?.binned === true, description: ExistCS?.description || '' });
                        }
                    }
                    for (var i = 0; i < cs.stocktakeLines.length; i++) {
                        if (!nonNewEntries.find((nne) => (nne.id === cs.stocktakeLines[i].id))) {
                            var newId = uuidv4();
                            var Approved = false;
                            if (cs.stocktakeLines[i]?.isApproved === null || cs.stocktakeLines[i]?.isApproved === undefined) {
                                Approved = false;
                            } else {
                                Approved = cs.stocktakeLines[i]?.isApproved;
                            }
                            nFL.push({ stocktakeLineId: cs.stocktakeLines[i].id, isApproved: cs.stocktakeLines[i].isApproved, Approved: Approved, id: newId, quantity: cs.stocktakeLines[i].newQuantity, binned: cs.stocktakeLines[i].binned === true, description: cs.stocktakeLines[i].description || '' });
                            nInv.push({ stocktakeLineId: cs.stocktakeLines[i].id, ...cs.stocktakeLines[i], id: newId, Approved: Approved, touched: true, stocktakeQuantity: cs.stocktakeLines[i].newQuantity, stocktakeOldQuantity: cs.stocktakeLines[i].oldQuantity, mixedGroupId: (cs.stocktakeLines[i]?.mixedGroupId || cs.stocktakeLines[i]?.MixedGroupId || null) });
                        }
                    }
                    setCurrentStocktake(cs);
                    setFullList(nFL);
                    setInventory(nInv);
                    if (cs.isComplete) {
                        setSortKey(null)
                    }
                    checkApprovedStatus(nFL);
                });
            });
        } else {
            // getInvData().then((data) => {
            //     setLoading(false);
            //     setFullList(data.map((dt, ind) => ({ id: ind, quantity: null })));
            //     setInventory(data.map((dt, ind) => ({ ...dt, id: ind })));
            // });
        }
    }, [reload, props.reload, props.warehouseId, currentStocktakeId]);

    React.useEffect(() => {
        const remNoStockItems = (stockItems) => {
            var newStockItems = stockItems.filter((si) => {
                return !si.isNonStockItem;
            });
            setStockItems(newStockItems);
        }
        if (newLines) {
            getAPIData('/StockItems/Get', remNoStockItems)
        }
    }, [newLines]);

    const checkApprovedStatus = (list) => {
        for (var i = 0; i < list.length; i++) {
            if (list[i].Approved && !list[i].isApproved) {
                var params = {
                    StocktakeLineId: list[i].stocktakeLineId,
                    Approver: user.name,
                    isApproved: true
                }
                postApi('/Inventory/ApproveStocktake', params);
            }
        }
    }

    const convertToValue = (arr) => {
        return arr[0] + '-' + arr[1];
    }
    const deconstructValue = (val) => {
        if (!val || typeof val !== 'string') {
            return [null, null];
        }
        return val.split('-').map((v) => {

            if (v === 'null') {
                return null
            } else if (v == 'true') {
                return true
            } else if (v == 'false') {
                return false
            } else {
                return Number(v)
            }
        }
        )
    }
    const validate = (complete) => () => {
        var warningMessages = [];
        var errorMessages = [];
        if (!staffMember) {
            errorMessages.push("You must enter a Staff Member");
        }
        if (complete) {
            for (var i = 0; i < fullList.length; i++) {
                if (fullList[i].quantity === null) {
                    errorMessages.push("You must report a status for each item in this list");
                    break;
                } else {
                    if (fullList[i].quantity < 0) {
                        errorMessages.push("You must enter a quantity greater than or equal to 0 for all items.");
                        break;
                    }
                }
            }
        }
        for (var i = 0; i < fullList.length; i++) {
            if (fullList[i].binned && !fullList[i].description?.trim()) {
                errorMessages.push("You must enter a description for all binned items");
                break;
            }
        }
        for (var i = 0; i < newList.length; i++) {
            if (!newList[i].stockItem) {
                errorMessages.push("You must select a stock item for all new lines");
                break;
            }
            if (!newList[i].lotSerialNbr) {
                errorMessages.push("You must select a lot serial number for all new lines");
                break;
            }
            if (!newList[i].expiryDate) {
                errorMessages.push("You must select an expiry date for all new lines");
                break;
            }
            var quant = fullList.find((fl) => fl.id === newList[i].id)?.quantity;
            if (!quant || quant === '') {
                errorMessages.push("You must enter a quantity for all new lines");
                break;
            }
        }
        const formatErrorMessage = (array) => {
            var errString = '';
            array.map((a) => {
                errString = errString + a + '<br/>';
            });
            return errString;
        }
        if (errorMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(errorMessages),
                icon: 'error',
                title: 'Oops...',

            });
        } else {
            submit(complete);
        }
    }
    const createNew = async () => {
        if (!currentStocktakeId) {
            setCreateLoading(true);
            //create stocktake
            postApi('/Inventory/CurrentStocktake', { WarehouseId: props.warehouseId, StaffMemberId: staffMember?.id }).then(async (currStocktake) => {
                var cst = await currStocktake.json()
                setCurrentStocktakeId(cst.id);


            });
        }
    }
    const submit = async (complete) => {
        var stocktakeId = currentStocktake ? currentStocktake.id : null;

        setLoading(true);
        var promArr = [];

        if (complete) {
            var paramsc = {
                StocktakeId: stocktakeId
            }
            await postApi('/Inventory/CompleteStocktake', paramsc);
        }


        setLoading(false);
        setCompleted(true);
        if (props.reload) {
            props.reload();
        }
    }
    const approve = async (approveThis) => {
        setLoading(true);

        if (fullList.some((line) => line.binned && !line.description?.trim())) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'You must enter a description for all binned items'
            });
            return;
        }

        if (editST) {
            validate(false)();
        }
        if (approveThis) {
            await postApi('/Inventory/ApproveStocktake', { StocktakeId: currentStocktake.id, Approver: user.name, IsApproved: true });
            setCompleted(true);
        } else {
            setReload(!reload);
        }



        setLoading(false);
        if (props.reload) {
            props.reload();
        }
    }
    const sortBy = (key, second) => () => {
        if ((sortKey?.main === key) && (sortKey?.second === second)) {
            setSortKey({ main: key, second: second, pos: !sortKey.pos });
        } else {
            setSortKey({ main: key, second: second, pos: true });
        }
    }
    const updateLineDetails = React.useCallback((id, details) => {
        setFullList((prevFullList) => prevFullList.map((line) => line.id === id ? { ...line, ...details } : line));
        setInventory((prevInventory) => prevInventory.map((line) => line.id === id ? {
            ...line,
            ...details,
            ...(details.quantity !== undefined ? { stocktakeQuantity: details.quantity } : {})
        } : line));
    }, []);
    const setFullListById = async (id, quantity, setMiniLoading, details = {}) => {
        setMiniLoading(true);
        setLineLoading((line) => [...line, id]);
        var find = fullList.find((fl) => fl.id === id);
        const binned = details.binned ?? find?.binned ?? false;
        const description = details.description !== undefined ? details.description : (find?.description || '');
        if ((quantity !== null) && (quantity !== undefined) && (quantity !== '')) {
            updateLineDetails(id, { quantity, binned, description });
            if (find.new) {
                var invSel = newList.find((inv) => inv.id === find.id);
                if (invSel && invSel.stockItem && invSel.lotSerialNbr && invSel.expiryDate) {
                    var params = {
                        StocktakeId: currentStocktake.id,
                        LotSerialNbr: invSel.lotSerialNbr,
                        StockItemId: invSel.stockItem.id,
                        ExpiryDate: textfieldDateFormat(new Date(invSel.expiryDate)),
                        Quantity: quantity,
                        Binned: binned,
                        Description: description
                    }
                    postApi('/Inventory/AddUpdateStockTakeItem', params).then(async (data) => {
                        var list = await data.json();
                        setMiniLoading(false);
                        //remove id from line loading
                        setLineLoading((line) => line.filter((l) => l !== id));
                        setFullList(prevFullList => {
                            var returnedStockline = list.find((l) => l.stockItemId === params.StockItemId && textfieldDateFormat(new Date(l.expiryDate)) === params.ExpiryDate && l.lotSerialNbr === params.LotSerialNbr);
                            return prevFullList.map((line) => line.id === id ? { ...line, stocktakeLineId: returnedStockline?.id } : line);
                        });
                    });
                }
            } else {
                var invSel = inventory.find((inv) => inv.id === find.id);
                if (invSel) {
                    const mgid = invSel?.mixedGroupId || null;
                    if (mgid && Array.isArray(invSel?.groupItems) && invSel.groupItems.length > 0) {
                        // Allocate entered quantity across group items proportionally to their portalQuantity
                        const baseTotal = invSel.groupItems.reduce((p, gi) => p + Number(gi?.portalQuantity ?? 0), 0);
                        let allocations = [];
                        if (baseTotal > 0) {
                            invSel.groupItems.forEach(gi => {
                                console.log(gi.portalQuantity, baseTotal, gi.portalQuantity / baseTotal, quantity);
                            });
                            allocations = invSel.groupItems.map(gi => ({
                                gi,
                                share: Math.floor((Number(gi?.portalQuantity ?? 0) / baseTotal) * Number(quantity || 0))
                            }));
                            const allocated = allocations.reduce((p, a) => p + a.share, 0);
                            let diff = Number(quantity || 0) - allocated;
                            let idx = 0;
                            while (diff !== 0 && idx < allocations.length) {
                                allocations[idx].share += (diff > 0 ? 1 : -1);
                                diff += (diff > 0 ? -1 : 1);
                                idx++;
                            }
                        } else {
                            const n = invSel.groupItems.length || 1;
                            const even = Math.floor(Number(quantity || 0) / n);
                            allocations = invSel.groupItems.map(gi => ({ gi, share: even }));
                            let rem = Number(quantity || 0) - (even * n);
                            let i = 0;
                            while (rem > 0 && i < allocations.length) { allocations[i].share += 1; rem--; i++; }
                        }

                        // Post for each group item
                        await Promise.all(allocations.map(({ gi, share }) => {
                            const params = {
                                StocktakeId: currentStocktake.id,
                                LotSerialNbr: invSel.lotSerialNbr,
                                StockItemId: gi?.stockItemId || gi?.stockItem?.id,
                                ExpiryDate: textfieldDateFormat(new Date(invSel.expiryDate)),
                                Quantity: share,
                                MixedGroupId: mgid,
                                Binned: binned,
                                Description: description
                            };
                            return postApi('/Inventory/AddUpdateStockTakeItem', params);
                        }));
                        setMiniLoading(false);
                        setLineLoading((line) => line.filter((l) => l !== id));
                    } else {
                        var params = {
                            StocktakeId: currentStocktake.id,
                            LotSerialNbr: invSel.lotSerialNbr,
                            StockItemId: invSel.stockItemId,
                            ExpiryDate: textfieldDateFormat(new Date(invSel.expiryDate)),
                            Quantity: quantity,
                            Binned: binned,
                            Description: description
                        }
                        postApi('/Inventory/AddUpdateStockTakeItem', params).then(async (data) => {
                            setMiniLoading(false);
                            setLineLoading((line) => line.filter((l) => l !== id));
                        })
                    }
                } else {
                    console.log('error lists dont match');
                }
            }
        }
    };
    const searchFilter = (data) => {
        const filterButton = deconstructValue(filterChoice); // [speciesId|null, isHalfshell|null]

        const matchesSpecies = () => {
            const wanted = filterButton[0];
            if (wanted === null) return true;
            const siSpecies = data.stockItem?.speciesId;
            if (siSpecies !== undefined && siSpecies !== null) return siSpecies === wanted;
            if (Array.isArray(data.groupItems)) {
                return data.groupItems.some(gi => (gi?.stockItem?.speciesId === wanted));
            }
            return false;
        };
        const matchesShell = () => {
            const wanted = filterButton[1];
            if (wanted === null) return true;
            const siShell = data.stockItem?.isHalfshell;
            if (typeof siShell === 'boolean') return siShell === wanted;
            if (Array.isArray(data.groupItems)) {
                return data.groupItems.some(gi => (gi?.stockItem?.isHalfshell === wanted));
            }
            return false;
        };

        const passCategory = matchesSpecies() && matchesShell();
        if (!passCategory) return false;

        // Text search
        if (!search) return true;
        const haystacks = [
            data.stockItem?.description,
            data.lotSerialNbr,
            data.estuary?.description
        ].filter(Boolean).map(s => String(s).toLowerCase());

        return haystacks.some(h => h.includes(search.toLowerCase()));
    }
    const addNewLine = React.useCallback(() => {
        var newId = uuidv4();
        setFullList(prevFullList => {
            return [{ id: newId, new: true, quantity: null }, ...prevFullList];
        });
        setInventory(invList => {
            return [{ id: newId, new: true }, ...invList];
        });
        setNewList(newL => {
            return [{ id: newId, new: true }, ...newL];
        })
        setNewLines(true);
        setSearch('');
    }, []);


    const updateNewList = (id, expiryDate, lotSerialNbr, stockItem, quantity) => {
        setNewList(prevNewL => {
            var findId = prevNewL.findIndex((fl) => fl.id === id);
            if (expiryDate) {
                prevNewL[findId].expiryDate = expiryDate;
            }
            if (lotSerialNbr) {
                prevNewL[findId].lotSerialNbr = lotSerialNbr;
            }
            if (stockItem) {
                prevNewL[findId].stockItem = stockItem;
            }
            return prevNewL;
        });
        setFullListById(id, quantity, (input) => { });
    }

    const removeNewLine = (id) => {
        setFullList(prevFullList => {
            return prevFullList.filter((fl) => fl.id !== id);
        });
        setInventory(invList => {
            return invList.filter((fl) => fl.id !== id);
        });
        setNewList(newL => {
            return newL.filter((fl) => fl.id !== id);
        });
        var lineId = fullList.find((fl) => fl.id === id)?.stocktakeLineId;
        if (lineId) {
            postApi('/Inventory/DeleteStockTakeLine', { stocktakeLineId: lineId });
        } else {
            console.log('no line id- regular delte');
        }
    };
    const markApproval = (id, val) => {
        setFullList(prevFullList => {
            var findId = prevFullList.findIndex((fl) => fl.id === id);
            prevFullList[findId]['Approved'] = val;
            return prevFullList;
        });
        // Find the inventory line for this id
        var invLine = fullList.find((fl) => fl.id === id);
        console.log(invLine)
        const mgid = invLine?.mixedGroupId || null;
        if (mgid) {
            // Approve all lines in the group using inventory as source of truth
        console.log(invLine)
            invLine.allIds.forEach(sid => {
                if (sid) {
                    var params = {
                        StocktakeLineId: sid,
                        Approver: user.name,
                        isApproved: val
                    };
                    postApi('/Inventory/ApproveStocktakeLine', params);
                }
            });
        } else if (invLine && invLine.stocktakeLineId) {
            var params = {
                StocktakeLineId: invLine.stocktakeLineId,
                Approver: user.name,
                isApproved: val
            };
            postApi('/Inventory/ApproveStocktakeLine', params);
        }
    }

    const inventorySort = React.useMemo(() => {
        return inventory?.sort((a, b) => {
            if (sortKey === null) {
                return (a.portalQuantity !== a.stocktakeQuantity) === (b.portalQuantity !== b.stocktakeQuantity) ? 0 : (a.portalQuantity !== a.stocktakeQuantity) ? -1 : 1;
            } else {
                var aOp = sortKey.second ? a[sortKey.main]?.[sortKey.second] : a[sortKey.main];
                var bOp = sortKey.second ? b[sortKey.main]?.[sortKey.second] : b[sortKey.main];

                if (aOp > bOp) {
                    return (sortKey.pos ? 1 : -1);
                } else if (aOp < bOp) {
                    return (sortKey.pos ? -1 : 1);
                }
                return 0;
            }
        })
    }, [inventory, sortKey]);

    const downloadStocktake = () => {
        var excelOutput = inventorySort.map((inv) => {
            return {
                'Lot Serial Nbr': inv.lotSerialNbr,
                'StockItem': inv.stockItem?.myobid,
                'Stocktake Quantity (Doz)': inv.stocktakeQuantity,
                'Binned': inv.binned ? 'Yes' : 'No',
                'Description': inv.description || ''
            }
        });
        return excelOutput;

    }
    const OpenInvHis = (lsn, si) => {
        setInvHistLSN(lsn);
        setInvHistSI(si);
        setInvHistOpen(true);
    }
    const handleCloseInvHist = () => {
        setInvHistLSN(null);
        setInvHistSI(null);
        setInvHistOpen(false);
    }
    const canEditVarianceDetails = isComplete && !isApproved && checkAccess(props.access, requiredApprovalAccess);

    if (!currentStocktakeId) {
        return <Box
            component="form"
            sx={{
                '& .MuiTextField-root': { m: 1, width: '24ch' },
            }}
            noValidate
            autoComplete="off"
        >
            {(stocktakeTests ? ((stocktakeTests.length == 0) ? <Grid container spacing={2} mb={1}>
                <Grid item xs={12} sm={12} md={6}>
                    <StaffMember staffId={null} driver={staffMember} setDriver={setStaffMember} disabled={currentStocktake} noTitle />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <SubmitButtonDisplayer error={error} completed={completed} loading={createLoading} allowed={checkAccess(props.access, requiredEditAccess)} submitFunc={createNew} handleClose={props.handleClose} title='Create New' />
                </Grid>
            </Grid> : <Grid container spacing={2} mb={1}>
                <Grid item xs={12} sm={12} md={6}>
                    {stocktakeTests.map((st) => {
                        return <Typography style={{ color: 'red' }}>
                            {st}
                        </Typography>
                    })}
                </Grid>
            </Grid>) : <CircularProgress />)}
        </Box >
    } else {

        return (
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '24ch' },
                }}
                noValidate
                autoComplete="off"
            >
                {/* Download button in top right corner */}
                {inventorySort ? <DownloadButton style={{ top: '40px', right: '20px', position: 'absolute' }} start={true} data={downloadStocktake()} /> : null}

                <Div>
                    <Grid container spacing={2} mb={1}>
                        <Grid item xs={12} sm={12} md={6}>
                            <StaffMember staffId={currentStocktake ? currentStocktake.staffMemberId : null} driver={staffMember} setDriver={setStaffMember} disabled={currentStocktake} noTitle />
                            <SelectWarehouse useCache warehouseId={props.warehouseId ? props.warehouseId : null} state={warehouse} setState={setWarehouse} disabled={true} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            {lineLoading.length==0?(isComplete ?
                                !editST ? <React.Fragment><div style={{ paddingTop: '8px', textAlign: 'left' }}>
                                    <SubmitButtonDisplayer error={error} completed={completed || isApproved} loading={loading} allowed={checkAccess(props.access, requiredApprovalAccess)} submitFunc={() => { approve(false) }} handleClose={props.handleClose} title='Save Approvals' />
                                </div>
                                    <div style={{ paddingTop: '8px', textAlign: 'left' }}>
                                        <SubmitButtonDisplayer error={error} completed={completed || isApproved} loading={loading} allowed={checkAccess(props.access, requiredApprovalAccess)} submitFunc={() => { approve(true) }} handleClose={props.handleClose} title='Submit for Reconciliation' />
                                    </div>
                                </React.Fragment>
                                    : <div style={{ paddingTop: '8px', textAlign: 'left' }}>
                                        <SubmitButtonDisplayer error={error} completed={completed} loading={loading} allowed={checkAccess(props.access, requiredEditAccess)} submitFunc={validate(true)} handleClose={props.handleClose} />
                                    </div>
                                : <React.Fragment><div style={{ paddingTop: '8px', textAlign: 'left' }}>
                                    <SubmitButtonDisplayer error={error} completed={completed} loading={loading} allowed={checkAccess(props.access, requiredEditAccess)} submitFunc={validate(false)} handleClose={props.handleClose} title='Save' />
                                </div>
                                    <div style={{ paddingTop: '8px', textAlign: 'left' }}>
                                        <SubmitButtonDisplayer error={error} completed={completed} loading={loading} allowed={checkAccess(props.access, requiredEditAccess)} submitFunc={validate(true)} handleClose={props.handleClose} />
                                    </div>
                                </React.Fragment>):<CircularProgress/>}
                        </Grid>
                    </Grid>

                    <h3 style={{ fontWeight: 450, display: 'inline' }}>Stock</h3>
                    {!isApproved && isComplete && checkAccess(props.access, requiredApprovalAccess) ? <IconButton aria-label="Label" onClick={() => { setEditST(true) }} >
                        <EditIcon />
                    </IconButton> : null}
                    {/* {!isComplete || (isComplete && editST) ? <IconButton aria-label="Label" onClick={() => { addNewLine() }} >
                        <AddIcon />
                    </IconButton> : null} */}
                    <JumboSearch onChange={(val) => { setSearch(val) }} />
                <ToggleButtonGroup value={filterChoice} exclusive onChange={(ev, val) => setFilterChoise(val ?? convertToValue([null, null]))} aria-label="text alignment">
                        <ToggleButton value={convertToValue([null, null])} aria-label="left aligned">
                            All
                        </ToggleButton>
                        <ToggleButton value={convertToValue([null, true])} aria-label="left aligned">
                            Halfshell
                        </ToggleButton>
                        {speciesList.map((sp) => {
                            return <ToggleButton value={convertToValue([sp.id, true])} aria-label="left aligned">
                                {sp.name} Halfshell
                            </ToggleButton>

                        })}
                        <ToggleButton value={convertToValue([null, false])} aria-label="left aligned">
                            Live
                        </ToggleButton>
                        {speciesList.map((sp) => {
                            return <ToggleButton value={convertToValue([sp.id, false])} aria-label="left aligned">
                                {sp.name} Live
                            </ToggleButton>

                        })}
                    </ToggleButtonGroup>
                    <Grid container spacing={2} mb={1}>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell onClick={sortBy('expiryDate')} >Use by Date<SwapVertIcon style={{ marginBottom: '-5px' }} /></TableCell>
                                        <TableCell onClick={sortBy('lotSerialNbr')}>Lot Serial Nbr<SwapVertIcon style={{ marginBottom: '-5px' }} /></TableCell>
                                        <TableCell onClick={sortBy('stockItem', 'description')}>StockItem<SwapVertIcon style={{ marginBottom: '-5px' }} /></TableCell>
                                        <TableCell onClick={sortBy('estuary', 'description')}>Estuary<SwapVertIcon style={{ marginBottom: '-5px' }} /></TableCell>
                                        {isComplete ? <TableCell onClick={sortBy('portalQuantity')}>Inventory Quantity (Doz)<SwapVertIcon style={{ marginBottom: '-5px' }} /></TableCell> : null}
                                        <TableCell onClick={sortBy('portalQuantity')}>{isComplete ? "Stocktake Quantity (Doz)" : "Quantity (Doz)"}<SwapVertIcon style={{ marginBottom: '-5px' }} /></TableCell>
                                        <TableCell>Binned</TableCell>
                                        <TableCell>Description</TableCell>
                                        {isComplete && !isApproved ? <TableCell>Approve</TableCell> : <TableCell></TableCell>}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {inventorySort ? (inventorySort).map((row, index) => {
                                        return <ModiTableRow show={searchFilter(row)} key={row.id} row={row} index={index} markApproval={markApproval} setFullListById={setFullListById} updateLineDetails={updateLineDetails} isComplete={isComplete} isApproved={isApproved} disabled={isApproved || (isComplete && !editST) || completed} canEditVarianceDetails={canEditVarianceDetails} frozenStocktake={frozenStocktake} stockItems={stockItems} updateNewList={updateNewList} removeNewLine={removeNewLine} OpenInvHis={OpenInvHis} />

                                    }) : null}
                                </TableBody>
                            </Table>
                        </Grid>

                    </Grid>
                </Div>
                <FormModal open={invHistOpen} handleClose={handleCloseInvHist} title={""} fixedWidth>
                    <InventoryHistory invHistLSN={invHistLSN} invHistSI={invHistSI} />
                </FormModal >
            </Box >
        );
    }
};

const ModiTableRow = (props) => {
    const newLine = props.row.new ? true : false;
    const [quantity, setQuantity] = React.useState(props.row.touched ? props.row.stocktakeQuantity : props.row.portalQuantity);
    const [keep, setKeep] = React.useState(null);
    const [expiryDate, setExpiryDate] = React.useState(null);
    const [lotSerialNbr, setLotSerialNbr] = React.useState(null);
    const [stockItem, setStockItem] = React.useState(null);
    const [markApproval, setMarkApproval] = React.useState(props.row.Approved);
    const [binned, setBinned] = React.useState(props.row.binned === true);
    const [description, setDescription] = React.useState(props.row.description || '');
    const [miniLoading, setMiniLoading] = React.useState(false);
    const { theme } = useJumboTheme();

    // Track if an action button was clicked to prevent duplicate API calls
    const actionButtonClicked = React.useRef(false);

    var statColor = 'white';
    console.log(props);
    var compareQuantity = props.row.portalQuantity ? props.row.portalQuantity : 0;
    if (props.isComplete) {
        compareQuantity = (props.row.stocktakeOldQuantity ? props.row.stocktakeOldQuantity : 0)
    }
    const isDecrease = Number(quantity) < Number(compareQuantity);
    const showDescription = binned || Math.abs(Number(compareQuantity) - Number(quantity)) > 10;
    const varianceDetailsDisabled = (props.disabled && !props.canEditVarianceDetails) || miniLoading;
    if ((Number(compareQuantity) !== Number(quantity)) && (quantity !== 0)) {
        statColor = theme.palette.oysterProducts.open;
    } else if ((keep === true) || (props.row.touched && (Number(compareQuantity) === Number(quantity)))) {
        statColor = theme.palette.oysterProducts.completed;
    } else if ((keep === false) || (props.row.touched && (0 === Number(quantity)))) {
        statColor = theme.palette.oysterProducts.cancelled;
    }

    const updateLotSerialNbr = (lsn) => {
        setLotSerialNbr(lsn);
        var newExpDate = adjustDateByStockItem(undoDateFormat(lsn.substring(lsn.length - 8, lsn.length)), stockItem)
        setExpiryDate(newExpDate);
        props.updateNewList(props.row.id, newExpDate, lsn, stockItem, quantity);
    }
    const updateStockItem = (si) => {
        setStockItem(si);
        if (lotSerialNbr) {
            var newExpDate = adjustDateByStockItem(undoDateFormat(lotSerialNbr.substring(lotSerialNbr.length - 8, lotSerialNbr.length)), si)
            setExpiryDate(newExpDate);
        }
        props.updateNewList(props.row.id, newExpDate, lotSerialNbr, si, quantity);
    }
    const updateExpiryDate = (ed) => {
        setExpiryDate(ed);
        props.updateNewList(props.row.id, ed, lotSerialNbr, stockItem, quantity);
    }
    if (!props.show) {
        return null;
    }
    return <TableRow key={props.row.id} style={{ backgroundColor: statColor }} >
        <TableCell>{!newLine ? dateFormat(props.row.expiryDate) :
            <DatePicker date={expiryDate} setDate={updateExpiryDate} label="Date" />
        }
        </TableCell>
        <TableCell>{!newLine ? <div>{props.row.lotSerialNbr}<IconButton aria-label="Label" onClick={() => { props.OpenInvHis(props.row.lotSerialNbr, props.row.stockItem) }} >
            <Info />
        </IconButton></div> :
            <SelectLotSerialNbr state={lotSerialNbr} setState={updateLotSerialNbr} />}
        </TableCell>
        <TableCell>{!newLine ? props.row.stockItem?.description :
            <SelectTextField key={'si' + props.row.id} title="Stock Item" state={stockItem} nameFunc={(r) => r.description} list={props.stockItems?.filter((si) => {
                if (props.frozenStocktake) {
                    return ((si.isFrozen));
                } else {
                    return (!(si.isFrozen));
                }
            })} setState={updateStockItem} disabled={props.disabled} />}
        </TableCell>
        <TableCell>{!newLine ? props.row.estuary?.description : (lotSerialNbr ? lotSerialNbr.estuary?.description : null)}
        </TableCell>

        {props.isComplete ? <TableCell><ControlledTextField key={'bi' + props.row.id} title="" state={Number(compareQuantity)} setState={(quant) => { }} style={{ "-webkit-text-fill-color": '#475259' }} disabled={true} number width={'100px'} />
        </TableCell> : null}
        <TableCell><ControlledTextField key={'bi' + props.row.id} title="" state={quantity} updateDataOnBlur={(quant, event) => {
            // Check if an action button was clicked recently
            if (actionButtonClicked.current) {
                console.log('Skipping API call - action button was clicked');
                actionButtonClicked.current = false; // Reset the flag
                return;
            }

            // Check if the next focused element is one of our action buttons
            const relatedTarget = event?.relatedTarget;
            console.log('Blur event - relatedTarget:', relatedTarget);
            console.log('Blur event - relatedTarget tagName:', relatedTarget?.tagName);
            console.log('Blur event - relatedTarget aria-label:', relatedTarget?.getAttribute?.('aria-label'));

            const isActionButton = relatedTarget && (
                relatedTarget.closest('button[aria-label="Label"]') ||
                relatedTarget.tagName === 'BUTTON'
            );

            console.log('Is action button:', isActionButton);

            // Only call API if not moving to an action button
            if (!isActionButton) {
                console.log('Calling setFullListById from blur');
                const nextBinned = Number(quant) < Number(compareQuantity) ? binned : false;
                setBinned(nextBinned);
                props.setFullListById(props.row.id, quant, setMiniLoading, { binned: nextBinned, description });
            } else {
                console.log('Skipping API call - user clicked action button');
            }
        }} setState={(quant) => { setQuantity(quant) }} style={props.disabled ? { "-webkit-text-fill-color": '#475259' } : {}} disabled={props.disabled || miniLoading} number width={'100px'} />
        </TableCell>
        <TableCell>
            {isDecrease ? <Checkbox checked={binned} disabled={varianceDetailsDisabled} onMouseDown={() => { actionButtonClicked.current = true; }} onChange={(event) => {
                const checked = event.target.checked;
                setBinned(checked);
                props.updateLineDetails(props.row.id, { binned: checked, description });
                props.setFullListById(props.row.id, quantity, setMiniLoading, { binned: checked, description });
            }} inputProps={{ 'aria-label': 'Binned' }} /> : null}
        </TableCell>
        <TableCell>
            {showDescription ? <TextField
                label="Description"
                value={description}
                required={binned}
                error={binned && !description.trim()}
                disabled={varianceDetailsDisabled}
                inputProps={{ maxLength: 500 }}
                onMouseDown={() => { actionButtonClicked.current = true; }}
                onChange={(event) => {
                    setDescription(event.target.value);
                    props.updateLineDetails(props.row.id, { binned, description: event.target.value });
                }}
                onBlur={() => props.setFullListById(props.row.id, quantity, setMiniLoading, { binned, description })}
            /> : null}
        </TableCell>
        {props.isComplete && !props.isApproved ?
            <TableCell>
                <FormGroup>
                    <FormControlLabel style={{ paddingLeft: '9px' }} control={<Checkbox checked={markApproval} onChange={(event) => { setMarkApproval(event.target.checked); props.markApproval(props.row.id, event.target.checked) }} />} label="" />
                </FormGroup>

            </TableCell>
            : (props.isComplete && props.isApproved ?
                <TableCell>
                    <FormGroup>
                        <FormControlLabel style={{ paddingLeft: '9px' }} control={<Checkbox checked={markApproval} disabled onChange={(event) => { setMarkApproval(event.target.checked); props.markApproval(props.row.id, event.target.checked) }} />} label="" />
                    </FormGroup>
                </TableCell>
                : null)}
        <TableCell>
            {!props.disabled ? (miniLoading ? <CircularProgress /> : <IconButton aria-label="Label" onMouseDown={() => { actionButtonClicked.current = true; }} onClick={() => { const nextQuantity = props.row.portalQuantity ? props.row.portalQuantity : 0; setKeep(true); setQuantity(nextQuantity); setBinned(false); props.setFullListById(props.row.id, nextQuantity, setMiniLoading, { binned: false, description }); console.log('Done button clicked'); }} >
                <DoneIcon />
            </IconButton>) : null}
            {!props.disabled ? (miniLoading ? null : <IconButton aria-label="Label" onMouseDown={() => { actionButtonClicked.current = true; }} onClick={() => { setKeep(false); setQuantity(0); props.setFullListById(props.row.id, 0, setMiniLoading, { binned, description }); console.log('Close button clicked'); }} >
                <CloseIcon />
            </IconButton>) : null}
            {newLine ? <IconButton aria-label="Label" onClick={() => { props.removeNewLine(props.row.id) }} >
                <DeleteIcon />
            </IconButton> : null}
        </TableCell>


    </TableRow>
}

export default PriceForm;

const SelectLotSerialNbr = (props) => {
    const [prn, setPrn] = React.useState('');
    const [returnedLSNs, setReturnedLSNs] = React.useState([]);
    const [loadingLSN, setLoadingLSN] = React.useState(false);
    const [lotNbr, setLotNbr] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [loadingDetails, setLoadingDetails] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    }
    const searchPRN = () => {
        setLoadingLSN(true);
        getAPIDataParamsReturn('/Inventory/SearchPRN', { LotNbrSubString: prn }).then((rlsn) => {
            setReturnedLSNs(rlsn);
            if (rlsn.length === 1) {
                setLotNbr(rlsn[0]);
            }
            setLoadingLSN(false);
        });
        setOpen(true);
    }
    const selectLSN = (LSN) => () => {
        setLotNbr(LSN);
        setOpen(false);
        props.setState(LSN);
    }
    return (lotNbr ?
        <div>{lotNbr}
            <IconButton aria-label="Label" onClick={() => { setLotNbr(null) }} >
                <CloseIcon />
            </IconButton>
        </div>
        : <React.Fragment><FormModal open={open} handleClose={handleClose} title={""} fixedWidth>
            <Typography variant="h6" id="modal-modal-title"> Choose a Lot Serial Number</Typography>
            {loadingLSN ? <CircularProgress /> : (returnedLSNs.length > 0 ? returnedLSNs.map((rlsn) => {
                return <Button style={{ marginTop: '20px' }} onClick={selectLSN(rlsn)} variant="outlined" disabled={false} >{rlsn}</Button>
            }) : 'No Matching Lot Serial Numbers')}
        </FormModal >
            <TextField
                id="outlined-required"
                label="PRN"
                value={prn}
                onChange={(e) => setPrn(e.target.value)}
            />
            <Button style={{ marginTop: '20px' }} onClick={searchPRN} variant="outlined" disabled={false} ><SearchIcon /></Button>
        </React.Fragment>)
}
